export default {
  title:       'Gestão dos meus dados',
  description: 'Informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados',
};
